import React from 'react';

import NoData from './no-data.component';


export default function MessageContent(props) {
    console.log(props);
    // all conversation
    let messages = props.messages?.messages.data;
    if(messages){
        let newElement = document.querySelector('#messageContainer');
        newElement.innerHTML='';

        messages.map(message => {
            // messages of reciever
            //light messages
            const userAuth = JSON.parse(localStorage.getItem('jwt'))?.user;
            let p = document.createElement("p");
            let article = document.createElement("article");

            if (userAuth.id ===  message.user.id) {

                article.className = 'message-sender-container';
                p.className = 'message-sender';  
            }
            else{
                article.className = 'message-receiver-container';
                p.className = 'message-receiver';
            }
            p.appendChild(document.createTextNode(message.text))
            article.appendChild(p);
            newElement.prepend(article);
        })
        newElement.scrollTop = newElement.scrollHeight - newElement.clientHeight
    }

    return (
        <main id="messageContainer" className="bg-light p-3 " style={{ height: '67vh', scrollBehavior: "smooth", overflow: "auto" }}>
            <NoData />
        </main>
    )
}